const BASE_URL = '/accounts/conformities';
const getConformityData = () => {
    return ApiClient.get(BASE_URL);
};

const activateConformity = () => {
    return ApiClient.post(BASE_URL, {}, { confirm_final_change: true });
};

export { getConformityData, activateConformity };
